import { useState } from "react";
import { ChevronDown, Heart } from "lucide-react";
import { CheckRow } from "@/components/ExploreFilters";

export function PreferencesCollapsible({ title, hint, categories, selected, onToggle, defaultOpen = false, testId }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div data-testid={testId} className="rounded-xl border border-border">
      <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} data-testid={`${testId}-toggle`}
        className="w-full flex items-center justify-between gap-2 px-3 py-2.5 text-left text-sm hover:bg-accent/40 rounded-xl transition-colors">
        <span className="flex items-center gap-2 font-medium flex-wrap">
          <Heart className="w-4 h-4 text-primary" />{title}
          <span className="text-muted-foreground font-normal">(opcional)</span>
          {selected.length > 0 && (
            <span className="rounded-full bg-primary text-primary-foreground text-[10px] font-bold px-1.5 py-0.5" data-testid={`${testId}-count`}>{selected.length}</span>
          )}
        </span>
        <ChevronDown className={`w-4 h-4 shrink-0 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>
      <div className={`grid transition-[grid-template-rows] duration-300 ease-out ${open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
        <div className="overflow-hidden" inert={open ? undefined : ""}>
          <div className="px-2 pb-3">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-1" data-testid={`${testId}-list`}>
              {categories.map((c) => (
                <CheckRow key={c} label={c} active={selected.includes(c)} onClick={() => onToggle(c)} testId={`${testId}-pref-${c}`} />
              ))}
            </div>
            {hint && <p className="text-xs text-muted-foreground mt-2 px-1">{hint}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
